import { Controller } from "stimulus"

export default class extends Controller {
  initialize() {
    const autoValue = this.data.get('auto')
    // If it's a number, use that as delay in ms, otherwise default to 2000 if true
    this.auto = autoValue === 'true' ? 2000 : parseInt(autoValue, 10) || 0
  }

  connect() {
    if (this.auto) {
      setTimeout(() => {
        navigator.clipboard.writeText(this.data.get('text'))
        window.open(this.data.get('url'), '_blank')
      }, this.auto)
    }
  }

  run(event) {
    event.preventDefault()
    var target = $(event.currentTarget)
    navigator.clipboard.writeText(this.data.get('text'))
    window.open(this.data.get('url'), '_blank')
  }
}
